import {
  collection,
  getDocs,
  getFirestore,
  doc,
  getDoc,
  setDoc,
  updateDoc,
  serverTimestamp,
} from 'firebase/firestore';
import { firebaseApp } from './firebaseConfig';

// 1. Get a reference to the Firestore service
const db = getFirestore(firebaseApp); // Assuming 'app' is your initialized Firebase app

export interface IUser {
  name: string;
  lastname: string;
  email: string;
  id?: string;
  lastEntered?: Date;
  firstEntered?: Date;
}
/**
 * Fetches all users from the 'users' collection once.
 */
export async function getAllUsers() {
  try {
    // 2. Get a reference to the 'users' collection
    const usersCollectionRef = collection(db, 'users');

    // 3. Get all documents in the collection
    const querySnapshot = await getDocs(usersCollectionRef);

    // 4. Create an array to hold the user objects
    const usersList: IUser[] = [];

    // Loop through the results (querySnapshot)
    querySnapshot.forEach((doc) => {
      // doc.id is the document ID
      // doc.data() is the document's content (the object you saved)
      usersList.push({
        id: doc.id,
        ...doc.data(), // Spreading the fields (e.g., name, email)
      } as IUser);
      console.log(`${doc.id} => ${JSON.stringify(doc.data())}`);
    });

    console.log('Fetched Users:', usersList);
    return usersList;
  } catch (error) {
    console.error('Error fetching documents: ', error);
  }
}

export async function getUserById(userId: string) {
  try {
    const userDocRef = doc(db, 'users', userId);
    const userDocSnap = await getDoc(userDocRef);

    if (userDocSnap.exists()) {
      console.log('User Data:', userDocSnap.data());
      return { id: userDocSnap.id, ...userDocSnap.data() };
    } else {
      console.log('No such user document!');
      return null;
    }
  } catch (error) {
    console.error('Error getting document: ', error);
  }
}

export interface SaveUserOnLoginParams {
  uid: string;
  email: string | null;
  name: string | null;
  photoURL?: string | null;
}

/**
 * On user login: save or update the user in the `users` collection.
 * Document ID = uid (Firebase Auth UID) so it matches userId used in subscriptions.
 * Sets userId, email, name; lastLogin on every login; createdAt only for new users.
 */
export async function saveOrUpdateUserOnLogin(params: SaveUserOnLoginParams): Promise<void> {
  const { uid, email, name, photoURL } = params;
  const userRef = doc(db, 'users', uid);
  try {
    const snap = await getDoc(userRef);
    const data = {
      userId: uid,
      email: email ?? null,
      name: name ?? null,
      ...(photoURL != null ? { photoURL } : {}),
      lastLogin: serverTimestamp(),
    };
    if (!snap.exists()) {
      await setDoc(userRef, { ...data, createdAt: serverTimestamp() });
    } else {
      await updateDoc(userRef, data);
    }
  } catch (e) {
    console.error('saveOrUpdateUserOnLogin failed:', e);
    throw e;
  }
}
